import axios from 'axios';
import { useNavigate } from 'react-router-dom';

let onUnauthorizedCallback = null;
let onSessionCallback = null;

let onNavigate = null 

function setOnUnauthorizedCallback(callback) {
  onUnauthorizedCallback = callback;
}

function setOnSessionCallback(callback) {
  onSessionCallback = callback;
}

function setOnNavigate(callback) {
  onNavigate = callback;
}

let baseURL;

if (window.location.hostname === 'finance.automoby.ge') {
  baseURL = 'https://finance.automoby.ge/api';
} else if (window.location.hostname === 'i-logistics.net') {
  baseURL = 'https://i-logistics.net/api';
} else if (window.location.hostname === 'crm.aig.com.ge') {
  baseURL =  'https://crm.aig.com.ge/api'; 
} else if (window.location.hostname === 'crm.autonomo.kz') {
  baseURL =  'https://crm.autonomo.kz/api'; 
} else if (window.location.hostname === 'localhost' || window.location.hostname === 'crmdev.aig.com.ge') {
  baseURL =  'https://crm.aig.com.ge/api'; 
} else if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'dev.i-logistics.net') {
  baseURL = 'https://i-logistics.net/api';
}  

let baseFileURL;

if (window.location.hostname === 'finance.automoby.ge') {
  baseFileURL = 'https://finance.automoby.ge';
} else if (window.location.hostname === 'i-logistics.net') {
  baseFileURL = 'https://i-logistics.net';
} else if (window.location.hostname === 'crm.aig.com.ge' || window.location.hostname === 'localhost') {
  baseFileURL =  'https://crm.aig.com.ge'; 
} else if (window.location.hostname === 'crm.autonomo.kz') {
  baseFileURL =  'https://crm.autonomo.kz'; 
} else if (window.location.hostname === 'localhost' || window.location.hostname === 'crmdev.aig.com.ge') {
  baseFileURL =  'https://crmdev.aig.com.ge';
} else if (window.location.hostname === '127.0.0.1') {
  baseFileURL = 'https://i-logistics.net';
}

const automobyApi = axios.create({
  baseURL: baseURL
});

 function setAuthToken(token) {
  automobyApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

 automobyApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

 automobyApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response.status === 401 && 
      originalRequest.url === '/refresh'
    ) {
      
      onUnauthorizedCallback() 
      redirectToLogin();  
      return Promise.reject(error);
    }

    if (
        error.response.status === 401 && 
        (originalRequest.url === '/login' || originalRequest.url === '/forgot-password' || originalRequest.url === '/register')
      ) { 
        
        onUnauthorizedCallback() 
        return Promise.reject(error);
      }
 

    if (error.response.status === 401 && !originalRequest._retry) {
 
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      try {
        const { data } = await automobyApi.post('/refresh', {
          refreshToken: refreshToken
        });

        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);

        setOnSessionCallback(data.accessToken)

        setAuthToken(data.accessToken);

        originalRequest.headers['Authorization'] = 'Bearer ' + data.accessToken;
        return automobyApi(originalRequest);
      } catch (err) {

        onUnauthorizedCallback() 
        redirectToLogin();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

function redirectToLogin() {
    onNavigate("login") 
}


export { setOnUnauthorizedCallback, setOnNavigate, setOnSessionCallback , baseURL, baseFileURL};
export default automobyApi;